// storage key
export const PORTKEY_OFF_RAMP_GUARDIANS_APPROVE_LIST = 'PORTKEY_OFF_RAMP_GUARDIANS_APPROVE_LIST';

export const PortkeyAssetLiftCycle = 'PortkeyAssetLiftCycle';

export const StorageKeyPrefix = 'Portkey';
